type DeepPartial<T> = {
    [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

import { useMemo } from 'react';

import {useContacts} from "#app/contexts/useContacts";
import {useUserConfig} from "#app/contexts/useUserConfig";

type UserInfoType = {
    data: {
        id: string
        email: string
        first_name: string
        configs: { id: number, key: string, value: string }[]
        contacts: { id: number, first_name: '' }[]
    }
}

export type UserWrapperType = {
    info: DeepPartial<UserInfoType>
    config: ReturnType<typeof useUserConfig>
    contacts: ReturnType<typeof useContacts>
}

export const useUserContext = (userInfo: UserInfoType): UserWrapperType => {

    const info = userInfo
    const config = useUserConfig(userInfo.data.configs)
    const contacts = useContacts(userInfo.data.contacts)
    const configSnapshot = JSON.stringify(config.config)
    const contactsSnapshot = contacts.sign

    return useMemo(
        () => ({
            info,
            config,
            contacts,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps -- snapshots avoid unstable object refs
        [configSnapshot, contactsSnapshot, info]
    );
}
